import React from 'react';
import {Modal} from 'react-bootstrap';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';

function ModalEliminarCandExp({
  isModalEliminarCandExpShown,
  hideModalEliminarCandExp,
  showModalEliminarCandExp,
  eliminarCandidatoExp,
  isEliminarButtonLoading,
}) {
  return (
    <Modal
      show={isModalEliminarCandExpShown}
      onHide={hideModalEliminarCandExp}
      onShow={showModalEliminarCandExp}>
      <Modal.Header>
        <Modal.Title>Eliminar experiencia</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Se <b>eliminará</b> la experiencia del candidato
      </Modal.Body>
      <Modal.Footer>
        <ButtonWithLoading
          type="danger"
          text="Eliminar experiencia"
          submit={eliminarCandidatoExp}
          loading={isEliminarButtonLoading}
          disabled={false}
        />
      </Modal.Footer>
    </Modal>
  );
}

export {ModalEliminarCandExp};
